import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Table, Badge, Money } from '../../index.js';
import THEME from '../../../theme.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Meta } from './style.js';
import CasePreviewByCaseId from '../../CasePreview/CasePreviewByCaseId.js';
export const VoucherDetails = (props) => {
    const lang = useSelector((s) => s.lang);
    const [showVoucherOpen, setShowVoucherOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: showVoucherOpen, onOpen: () => setShowVoucherOpen(true), onClose: () => setShowVoucherOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                props.details.voucherTypeId && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.caseVoucherInfoType)),
                    React.createElement("td", null, lang.economyVoucherTypeLabels[props.details.voucherTypeId] || props.details.label))),
                props.details.referenceId && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.referenceId)),
                    React.createElement("td", null, props.details.referenceId))),
                props.details.caseId && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.voucherInfoMoveToCase)),
                    React.createElement("td", null,
                        React.createElement(CasePreviewByCaseId, { caseId: props.details.caseId })))),
                props.details.createdAt && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.caseVoucherInfoCreatedAt)),
                    React.createElement("td", null, moment(props.details.createdAt).format(THEME.DATE_FORMAT_LONG)))),
                props.details.category && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.caseVoucherInfoCategory)),
                    React.createElement("td", null, lang.economyCategories[props.details.category] || props.details.category))),
                props.details.state && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.caseVoucherInfoState)),
                    React.createElement("td", null,
                        React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, props.details.state)))),
                !!props.details.amount && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.amount)),
                    React.createElement("td", null,
                        React.createElement(Money, { amount: props.details.amount })))),
                props.details.currency && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.currency)),
                    React.createElement("td", null, props.details.currency))),
                props.details.text && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.voucherInfoText)),
                    React.createElement("td", null, props.details.text))),
                props.details.date && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.date)),
                    React.createElement("td", null, moment(props.details.date).format(THEME.DATE_FORMAT_LONG)))),
                props.details.dueDate && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.dueDate)),
                    React.createElement("td", null, moment(props.details.dueDate).format(THEME.DATE_FORMAT_LONG)))),
                props.details.interest && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.interestRate)),
                    React.createElement("td", null, props.details.interest))),
                props.details.interestStartDate && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.interestStartDate)),
                    React.createElement("td", null, moment(props.details.interestStartDate).format(THEME.DATE_FORMAT_LONG)))),
                props.details.interestEndDate && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.economy.interestEndDate)),
                    React.createElement("td", null, moment(props.details.interestEndDate).format(THEME.DATE_FORMAT_LONG))))))));
};
//# sourceMappingURL=VoucherDetails.js.map